import { slugifyName } from '@logic/helpers/location';
export var Images = {
    details: function (name) { return "details/" + slugifyName(name) + ".jpg"; },
    mobile: function (name) { return "mobile/" + slugifyName(name) + ".jpg"; },
    detailsTablet: function (name) { return "details-tablet/" + slugifyName(name) + ".jpg"; },
    eventList: function (name) { return "event-list/" + slugifyName(name) + ".jpg"; },
    advancedSearch: function (name) { return "advanced-search/" + slugifyName(name) + ".jpg"; },
    hottest: function (name) { return "hottest/" + slugifyName(name) + ".jpg"; },
};
